export default "__VITE_ASSET__Dp$P_7UG__"